import { render, staticRenderFns } from "./numberInfo.vue?vue&type=template&id=6d0105c3"
import script from "./numberInfo.vue?vue&type=script&lang=js"
export * from "./numberInfo.vue?vue&type=script&lang=js"
import style0 from "./numberInfo.vue?vue&type=style&index=0&id=6d0105c3&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports